import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6d67ef4f")

_pushScopeId("data-v-6d67ef4f")
const _hoisted_1 = {
  key: 1,
  class: "overflow-y-auto h-screen"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Configurable Price ", -1)
const _hoisted_5 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_6 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("button", { class: "cursor-not-allowed text-white bg-gray-lp-600 px-8 text-12px xxl:text-14px py-2 xxl:py-3 font-bold rounded-md focus:outline-none" }, " Simpan ", -1)
const _hoisted_8 = { class: "flex flex-row py-6" }
const _hoisted_9 = { class: "w-2/3 pr-8 pl-4 text-12px xxl:text-14px" }
const _hoisted_10 = { class: "w-3/4" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Nama Harga ", -1)
const _hoisted_13 = { class: "py-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 py-3" }, " Adjusted by ", -1)
const _hoisted_15 = { class: "flex flex-col text-12px xxl:text-14px border-t border-gray-lp-400 mt-6" }
const _hoisted_16 = { class: "py-3" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold mt-2 text-12px xxl:text-14px text-black-lp-300" }, " Status Harga ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Klik tombol dibawah untuk mengaktifkan harga. ", -1)
const _hoisted_19 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300 my-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_21 = { class: "ml-4" }
const _hoisted_22 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_23 = { class: "py-3" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Status Harga ", -1)
const _hoisted_25 = { class: "text-gray-lp-300 my-1" }
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = { class: "py-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_29 = { class: "text-gray-lp-300 my-1" }
const _hoisted_30 = { class: "text-gray-lp-500" }
const _hoisted_31 = { class: "py-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_33 = { class: "text-gray-lp-300 my-1" }
const _hoisted_34 = { class: "text-gray-lp-500" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                class: "w-5 mr-3 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                alt: "back"
              }),
              _hoisted_4
            ]),
            (_ctx.isValidate)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_button_fill, {
                    title: "Simpan",
                    class: "px-8 bg-red-lp-300",
                    onClick: _ctx.onOpenConfirmation
                  }, null, 8, ["onClick"])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_6, [
                  _hoisted_7
                ]))
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataDetail.configurablePriceName = $event)),
                    class: 
                `text-gray-lp-600 py-1.5 xxl:py-3 px-3 rounded border opacity-50 border-gray-lp-400 focus:outline-none my-2 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              ,
                    disabled: _ctx.isDisabled
                  }, null, 10, ["disabled"]), [
                    [_vModelText, _ctx.dataDetail.configurablePriceName]
                  ])
                ]),
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_MultipleSelectSearch, {
                    options: _ctx.penaltyAdjustedBys,
                    modelValue: 
                _ctx.dataDetail.configurableSttAdjustment.mapPenaltyAdjustedBy
              ,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.dataDetail.configurableSttAdjustment.mapPenaltyAdjustedBy
               = $event)),
                    keyName: "name",
                    keyValue: "value",
                    placeholder: "Pilih peran"
                  }, null, 8, ["options", "modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode("div", {
                      onClick: _cache[4] || (_cache[4] = () => _ctx.onOpenStatusConfigurablePrice()),
                      class: 
                  `toggle-switch inline-block cursor-pointer ${
                    _ctx.dataDetail.configurablePriceStatus === 'Active'
                      ? 'toggle-active bg-red-lp-100'
                      : 'bg-gray-lp-200'
                  }`
                
                    }, [
                      _hoisted_20
                    ], 2),
                    _createVNode("div", _hoisted_21, _toDisplayString(_ctx.dataDetail.configurablePriceStatus === "Active"
                    ? "Aktif"
                    : "Tidak Aktif"), 1)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", {
                      class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.configurablePriceStatus === 'Active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.configurablePriceStatus === 'Active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                    }, [
                      _createVNode("span", null, _toDisplayString(_ctx.dataDetail.configurablePriceStatus === "Active"
                      ? "Active"
                      : "Inactive"), 1)
                    ], 2)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.dataDetail.configurablePriceCreatedAt)), 1),
                _createVNode("div", _hoisted_30, _toDisplayString(_ctx.dataDetail.configurablePriceCreatedBy), 1)
              ]),
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("div", _hoisted_33, _toDisplayString(_ctx.formatDate(_ctx.dataDetail.configurablePriceUpdatedAt)), 1),
                _createVNode("div", _hoisted_34, _toDisplayString(_ctx.dataDetail.configurablePriceUpdatedBy), 1)
              ])
            ])
          ])
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.handlerCancelClose,
      onSubmit: _ctx.handlerClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseStatusConfigurableAktif,
      onSubmit: _ctx.changeStatusConfigurableAktif,
      title: "Konfirmasi Pengaktifan",
      message: "Anda yakin ingin mengaktifkan Harga “STT Adjustment Penalty” ?",
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openStatusConfigurableAktif]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: _ctx.onCloseStatusConfigurableNonAktif,
      onSubmit: _ctx.changeStatusConfigurableNonAktif,
      title: "Konfirmasi Penonaktifan",
      message: "Anda yakin ingin menonaktifkan Harga “STT Adjustment Penalty” ? ",
      image: "warning",
      textSuccess: "Non-aktifkan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openStatusConfigurableNonAktif]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.update,
      onClose: _ctx.onCloseConfirmation,
      title: "Konfirmasi Perubahan",
      message: 
      `Anda yakin ingin menyimpan perubahan detail Harga “STT Adjustment Penalty” ?`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.confirmation()]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Perubahan Disimpan",
      message: `Detail Harga “STT Adjustment Penalty” berhasil diubah.`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.modalSuccess]
    ])
  ], 64))
})